import Detectors from '@diziner/Utils/Detectors';
document.addEventListener('DOMContentLoaded', () => {
    if (Detectors.isInternetExplorer()) {
        document.querySelector('html')?.classList.add('is-internet-explorer');
    }
});
